/**
 * request 方法
 */
import { BridgeType, callGrowthMSIBridge, getBridgeType } from "./base";

/* ----- MSI.request 类型声明 start ----- */
// https://msi-extend.sankuai.com/api?tab=C&id=1539
interface MSIRequestProps {
  url: string;
  data?: any;
  header?: Record<string, string>;
  timeout?: number; // 超时时间，默认 60000 ms
  method: 'GET' | 'POST';
  dataType?: string; // 'json'
  requestDataType?: 'json' | 'base64' | 'application/x-www-form-urlencoded'; // 'json'
  responseType?: 'text' | 'arrayBuffer'; // 'text'
  success?: (result: MSIRequestSuccessCbParams) => void;
  fail?: (err: MSIRequestFailCbParams) => void;
  complete?: () => void;
}

export interface MSIRequestSuccessCbParams {
  data: any;
  header: Record<string, string>;
  statusCode: number;
  errMsg: string;
  errno: number;
}

interface MSIRequestFailCbParams {
  errMsg: string; // 响应信息
  errno: number; // 响应码
}
/* ----- MSI.openLink 类型声明 end ----- */

interface RequestProps {
  url: string;
  data?: any;
  header?: Record<string, string>;
  timeout?: number; // 超时时间，默认 60000 ms
  method: 'GET' | 'POST';
  dataType?: string; // 'json'
  requestDataType?: 'json' | 'base64' | 'application/x-www-form-urlencoded'; // 'json'
  responseType?: 'text' | 'arrayBuffer'; // 'text'
  onSuccess?: (result: MSIRequestSuccessCbParams) => void;
  onFail?: (err: MSIRequestFailCbParams) => void;
  onComplete?: () => void;
}

export function request(props: RequestProps) {
  if (!props.url || !props.method) {
    if (typeof props.onFail === "function") {
      props.onFail({
        errMsg: "url or method is empty",
        errno: 400,
      });
    }
  }
  const bridgeType = getBridgeType();
  switch (bridgeType) {
    case BridgeType.KNB:
      break;
    case BridgeType.MSI:
      break;
    case BridgeType.GROWTH_MSI:
      callGrowthMSIBridge("request", {
        url: props.url,
        data: props.data,
        header: props.header,
        timeout: props.timeout,
        method: props.method,
        dataType: props.dataType,
        requestDataType: props.requestDataType,
        responseType: props.responseType,
        success: (result: MSIRequestSuccessCbParams) => {
          if (typeof props.onSuccess === "function") {
            props.onSuccess(result);
          }
        },
        fail: (err: MSIRequestFailCbParams) => {
          if (typeof props.onFail === "function") {
            props.onFail(err);
          }
        },
      } as MSIRequestProps);
      break;
    default:
      break;
  }
}